const metaAuth = {
  auth: 1,
  keepAlive: false,
};

export default [
  {
    path: "/sw",
    name: "sw",
    meta: metaAuth,
    component: () => import("@/views/basePublishSite/index.vue"),
  },
  {
    path: "/sw/gameDetail",
    name: "sw/gameDetail",
    meta: metaAuth,
    component: () => import("@/views/basePublishSite/gameDetail/index.vue"),
  },
];
